{
  "top-salons-page": {
    "text": {
      "title": "Nejlepší salony",
      "hint": "Objevte nejoblíbenější kosmetické salony ve vašich oblíbených městech.",
      "country-label": "Země",
      "country": {
        "DE": "Německo",
        "CH": "Švýcarsko",
        "NL": "Nizozemsko"
      }
    },
    "meta": {
      "title": "Nejlepší salony | Beauty Booking",
      "description": "Objevte nejoblíbenější kosmetické salony v Německu, Švýcarsku a Nizozemsku."
    }
  }
}
